var _path, _path2, _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgShipmentDepartureGrey(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_472_9305)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_472_9305",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H28V28H0V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_472_9305)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_472_9305",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 28,
    height: 28
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 0H28V28H0V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_472_9305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.47979 16.9043H1.86005",
    stroke: "#E2E2E2",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.6278 10.7437H6.33185M6.6278 12.5814H6.33185",
    stroke: "#E2E2E2",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.60423 14.6793V8.8808H8.35539V14.6793M4.60358 8.8808L2.86713 6.3313H10.0924L8.35604 8.8808",
    stroke: "#E2E2E2",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3811 14.6794V15.8747C20.3811 16.4433 19.9202 16.9042 19.3516 16.9042H12.1315C11.5629 16.9042 11.102 16.4433 11.102 15.8747V14.6792H1.86005V16.8997C1.86005 18.7424 3.35388 20.2362 5.1966 20.2362H23.9092L27.4423 14.68L20.3811 14.6794Z",
    stroke: "#E2E2E2",
    strokeWidth: 1.16667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_472_9305)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.9444 6.61108L25.6667 9.33331M25.6667 9.33331L22.9444 12.0555M25.6667 9.33331L18.6667 9.33331",
    stroke: "#E2E2E2",
    strokeWidth: 0.777778,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_472_9305"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_472_9305"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 17.5,
    y: 4.66675,
    width: 9.33333,
    height: 9.33333,
    rx: 1.55556,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShipmentDepartureGrey);
export default __webpack_public_path__ + "static/media/shipmentDepartureGrey.c09136229ad37836c75e38c553b840a4.svg";
export { ForwardRef as ReactComponent };